define('gameday-index-gdapp/GDIndexAppComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','app-console/app-console'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		logg = require("app-console/app-console");

	// instance variables
	var Superclass,
		appConfig = {
			version: "1.3.0",
			appName: "gdapp_responsive",
			appType: "wired/release"
		};

	function GDApp(compID, divID) {
		this.componentID = compID;
		this.targetDiv = divID;

		this.init();
	}


	BaseClass.spawn(GDApp).define({
		init: function() {
			var gdScriptTag = document.createElement('script');

			logg.log(this.targetDiv);

			this.buildAppSettings();

			// Append proper GameDay build script based on url params
			/*gdScriptTag.setAttribute('src',
				"http://ui.qa.bamstatic.com/fedapp/gameday/" + appConfig.appName + "/" + appConfig.appType + "/" + appConfig.version + "/js/gdapp.min.js");
			document.head.appendChild(gdScriptTag);*/

			this.initialized = true;

			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		buildAppSettings: function() {
			// expand / extend the appConfig obj from above
			// iterate through config objects to construct the prpper params
		}
	});

	Superclass = GDApp.superclass;
	return GDApp;
});
